import React from "react";

// Maps API status strings -> badge color class + display label.
// The API uses: draft, pending, approved, rejected, deleted, generating, live, error.
// The README lifecycle: Extracting -> Pending Review -> Approved -> Generating -> Live -> Error
const STATUS_MAP = {
  extracting: { label: "Extracting", className: "badge-gray" },
  draft: { label: "Pending Review", className: "badge-blue" },
  pending: { label: "Pending Review", className: "badge-blue" },
  approved: { label: "Approved", className: "badge-green" },
  generating: { label: "Generating", className: "badge-yellow" },
  live: { label: "Live", className: "badge-green-bright" },
  rejected: { label: "Rejected", className: "badge-red" },
  error: { label: "Error", className: "badge-red" },
  deleted: { label: "Deleted", className: "badge-gray" },
};

/**
 * StatusBadge — colored pill rendering an IO's lifecycle status.
 *
 * @param {{ status: string }} props
 */
export default function StatusBadge({ status }) {
  const entry = STATUS_MAP[(status || "").toLowerCase()] || {
    label: status || "Unknown",
    className: "badge-gray",
  };
  return <span className={`status-badge ${entry.className}`}>{entry.label}</span>;
}

export { STATUS_MAP };